const helpers = window.BASE_HELPERS || {};
const { Mobile, Copy } = helpers;

class Single {
    constructor() {
        this.init();
    }

    init() {
        Copy.initCopy();
    }
}

(() => {
    new Single();
})();

export default Single;